// ---------- HomePage.js ----------
import HeroSlider from "./HeroSlider";
import WhatWeDo from "./WhatWeDo";
import "./home.css";
import WhyChoose from "./whycho";
import CircularSlider from "./CircularSlider";
import EmptyBorder from "./EmptyBorder";

function HomePage() {
  return (
    <>
      <HeroSlider />

      <div className="features-section">
        <div className="feature-card">
          <img src="/icons/Financial Support.png" className="feature-icon" alt="" />
          <h3 className="feature-card-title">Financial Support</h3>
          <p className="feature-card-text">
Financial support is the foundation of a secure and stress-free life. It helps individuals and families manage unexpected expenses, achieve life goals, and maintain stability during challenging times. Through the right financial planning and protection, you can safeguard your future and live with confidence.         </p>
        </div>

        <div className="feature-card">
          <img src="/icons/Tax Benefits.png" className="feature-icon" alt="" />
          <h3 className="feature-card-title">Tax Benefits</h3>
          <p className="feature-card-text">
Smart financial planning not only secures your future but also helps you save more on taxes. By choosing the right insurance and investment solutions, you can legally reduce your tax liability while building long-term wealth.
          </p>
        </div>

        <div className="feature-card">
          <img src="/icons/Quick & Trustworthy.png" className="feature-icon" alt="" />
          <h3 className="feature-card-title">Quick & Trustworthy</h3>
          <p className="feature-card-text">
   Fast, transparent, and reliable financial solutions you can trust.Quick approvals with complete honesty and clarity.Trusted guidance for all your insurance, investment, and loan needs. Simple processes, speedy service, and dependable support.Your time matters – we deliver financial solutions quickly and responsibly.          </p>
        </div>
      </div>

       <CircularSlider /> 
      <EmptyBorder />
      <WhyChoose />
      <WhatWeDo />

      <section className="assist-section">
        <div className="assist-left">
          <img src="/office.png" alt="Company" className="assist-image" />
        </div>

        <div className="assist-right">
          <h1 className="assist-subtitle">ABOUT COMPANY</h1>

          <h2 className="assist-title">
            We're Here To Protect What Matters Most <br /> For You & Your Future
          </h2>

          <p className="assist-text">
            We are Aerlis Gro, a trusted insurance services provider committed to
            safeguarding your family, your business, and your future.
          </p>

          <div className="assist-contact-box">
            <div className="assist-btn">Contact Us</div>
            <div className="assist-call">
              <span className="call-number">+91 72000 39384</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomePage;
